/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Time conversion constants for duration calculations and time-based operations.</blockquote>
 * 
 * @example
 * ```typescript
 * import { TIME_CONVERSION } from '@shared/constants';
 * 
 * // Convert milliseconds to minutes
 * const durationMinutes = Math.round(milliseconds / TIME_CONVERSION.MILLISECONDS_PER_MINUTE);
 * 
 * // Convert seconds to minutes
 * const durationMinutes = Math.round(seconds / TIME_CONVERSION.SECONDS_PER_MINUTE);
 * ```
 */
export const TIME_CONVERSION = {
  /** Milliseconds per second */
  MILLISECONDS_PER_SECOND: 1000,
  /** Seconds per minute */
  SECONDS_PER_MINUTE: 60,
  /** Milliseconds per minute */
  MILLISECONDS_PER_MINUTE: 60 * 1000,
  /** Minutes per hour */
  MINUTES_PER_HOUR: 60,
  /** Hours per day */
  HOURS_PER_DAY: 24,
} as const;
